export default "__VITE_ASSET__o9zw2dEn__"